import React from "react";
import { Breadcrumbs } from "@material-ui/core";

var Breadcrumb = function Breadcrumb(props) {
  return /*#__PURE__*/React.createElement(Breadcrumbs, {
    separator: props.separator,
    "aria-label": "breadcrumb"
  }, props.children);
};

export { Breadcrumb };